module.exports = __webpack_public_path__ + "static/media/logo-white-h.1c016f43.svg";